import languageConfigData from '../../../assets/data/language-config.json';

export class LanguageConstants {
  public static readonly SUPPORTED_LANGUAGE_CODES: string[] =
    languageConfigData.languages.map((lang) => lang.code);
  public static readonly SUPPORTED_LANGUAGE_NAMES: string[] =
    languageConfigData.languages.map((lang) => lang.name);
  public static readonly DEFAULT_LANGUAGE_CODE: string =
    languageConfigData.defaultLanguage;
  public static readonly SUPPORTED_LANGUAGES = languageConfigData.languages;
  public static readonly GENDER_REQUIRED_LANGUAGES: string[] =
    languageConfigData.languages
      .filter((lang) => lang.requiresGender)
      .map((lang) => lang.code);
  public static readonly GENDER_OPTIONAL_LANGUAGES: string[] =
    languageConfigData.languages
      .filter((lang) => !lang.requiresGender)
      .map((lang) => lang.code);
}
